import * as React from "react"
import * as CheckboxPrimitive from "@radix-ui/react-checkbox"
import { Check } from "lucide-react"

import { cn } from "../../lib/utils"

const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({ className, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn(
      "peer h-5 w-5 shrink-0 rounded-md border border-brand-border bg-brand-background ring-offset-brand-background focus-visible:outline-none focus:ring-2 focus:ring-brand-gold/20 focus:border-brand-gold disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-brand-gold data-[state=checked]:text-white dark:border-brand-border dark:bg-brand-background dark:ring-offset-brand-dark dark:focus:border-brand-gold dark:focus:ring-brand-gold/20 dark:data-[state=checked]:bg-brand-gold",
      className
    )}
    {...props}
  >
    <CheckboxPrimitive.Indicator
      className={cn("flex items-center justify-center text-current")}
    >
      <Check className="h-4 w-4" />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
))
Checkbox.displayName = CheckboxPrimitive.Root.displayName

export { Checkbox }
